import React from "react"
import {
  isCategoryActive,
  selectProductCategory,
  unselectProductCategory,
} from "../../../../utils/filters"
import { useAlgoliaSearchState } from "../../../controller/state"
import { CategoriesTreeItem } from "../../../controller/state/categories"
import ProductCategoryLevel from "../../../filters/ProductCategoryLevel"
import FilterCategoryContainer from "../FilterCategoryContainer"

interface Props {
  show: boolean
  onClose: () => void
}

const FiltersModalProductCategoriesFilter = ({ show, onClose }: Props) => {
  const {
    uiFilters,
    updateSearchParams,
    searchParams,
  } = useAlgoliaSearchState()

  const [levels, setLevels] = React.useState<string[]>([])

  const handleBack = () => {
    if (levels.length > 0) {
      setLevels(levels.slice(0, levels.length - 1))
    } else {
      onClose()
    }
  }

  if (!uiFilters?.categories.root) {
    return <></>
  }

  const findNode = (
    levelItems: CategoriesTreeItem[],
    path: string[],
    currentLevel: number
  ): CategoriesTreeItem | undefined => {
    const segment = path[currentLevel]
    const node = levelItems.find((x) => x.code === segment)
    if (currentLevel === path.length - 1) {
      return node
    }
    return findNode(node?.children ?? [], path, currentLevel + 1)
  }

  const getCurrentLevel = () => {
    if (levels.length > 0) {
      return findNode(uiFilters.categories.root, levels, 0)?.children
    } else {
      return uiFilters.categories.root
    }
  }

  const unselectOption = (option: CategoriesTreeItem) => {
    updateSearchParams((state) => {
      return {
        ...state,
        categoryCodes: unselectProductCategory(
          searchParams,
          option,
          uiFilters.categories
        ),
      }
    })
  }

  const selectOption = (option: CategoriesTreeItem) => {
    updateSearchParams((state) => {
      return {
        ...state,
        categoryCodes: selectProductCategory(searchParams, option),
      }
    })
  }

  const toggleOption = (option: CategoriesTreeItem) => {
    if (!isCategoryActive(option)) {
      selectOption(option)
    } else {
      unselectOption(option)
    }
  }

  const expandOption = (option: CategoriesTreeItem) => {
    setLevels([...levels, option.code])
  }

  return (
    <FilterCategoryContainer show={show} onBack={handleBack}>
      <ProductCategoryLevel
        items={getCurrentLevel() ?? []}
        onOptionToggle={toggleOption}
        onOptionExpand={expandOption}
      />
    </FilterCategoryContainer>
  )
}

export default FiltersModalProductCategoriesFilter
